<script>
  import { onDestroy, onMount } from "svelte";
  import { deviceTypes } from "../../editor/component/artboard.js";
  import {
    withPPI,
    devicePreview,
    systemLog,
    viewSpecs,
    data,
    dataInfo,
    updatePreference,
  } from "../../editor/storage.js";
  import { firstLevelMenus } from "../../editor/menuSchema.js";
  import { device_ppi } from "../../editor/component/artboard.js";
  let specList = {};
  let scale_const = 1.2
  withPPI.subscribe((val) => {
    if (val) {
      $viewSpecs.forEach((spec) => {
        let parent = document.querySelector("#dupo-view-" + spec.uid);
        let scale = Math.min((device_ppi / spec.artboard.ppi) * scale_const, 1);
        if (parent) {
          parent.style.width = scale * spec.artboard.device_width + 32 + "px";
          parent.style.height = scale * spec.artboard.device_height + 32 + "px";
        }
      });
    } else {
      $viewSpecs.forEach((spec) => {
        let parent = document.querySelector("#dupo-view-" + spec.uid);
        if (parent) {
          parent.style.width = "auto";
          parent.style.height = "auto";
        }
      });
    }
  });
  async function loadViews(specs) {
    specList = {};
    specs.forEach((spec) => {
      if (!specList[spec.artboard.screen_type])
        specList[spec.artboard.screen_type] = [];
      specList[spec.artboard.screen_type].push(spec);
    });
    specs.forEach((spec) => {
      spec.render($data, $dataInfo, () => {});
    });
    window.viewSpecs = specs;
    return true;
  }
  onMount(() => {
    devicePreview.set(true);
    $systemLog.log({ message: "See display previews" });
    let reversePPI = $withPPI ? true : false;
    withPPI.set(false);
    loadViews($viewSpecs).then(() => {
      if (reversePPI) {
        withPPI.set(true);
      }
    });
  });
  onDestroy(() => {
    devicePreview.set(false);
    $systemLog.log({ message: "Turn off display previews" });
  });
</script>

{#if $devicePreview}
  <h2 class="mb-0">
    {firstLevelMenus["preview"]?.title || "Device preview"}
  </h2>
  <div class="dupo-menu-pane mb-0" style="margin-top: -0.5rem;">
    <div id="ppi-check" class="dupo-menu-pane-row">
      <button
        type="button"
        class="menu-second-level"
        on:click={() => {
          updatePreference("withPPI", !$withPPI);
          // withPPI.set(!$withPPI);
          $systemLog.log({
            message: "Toggled PPI scaling (" + $withPPI + ")",
            option: $withPPI,
          });
        }}
      >
        <i
          class={`bi bi-${$withPPI ? "check-square-fill" : "square"} me-1 ${
            $withPPI ? "checked" : "unchecked"
          }`}
        /> PPI rescaled
      </button>
    </div>
  </div>
  <div class="mb-1" id="preview-column">
    {#each Object.keys(deviceTypes) as dtype}
      {#if specList[dtype]}
        {#each specList[dtype] as spec}
          <div>
            <div class="preview-heading">
              <i class={`bi bi-${deviceTypes[dtype]?.icon || "display"}`} />
              {dtype} / {spec.artboard.name}
            </div>
            <div class="mb-0" style="line-height: 100%;">
              <div
                id={"dupo-view-" + spec.uid}
                style="padding: 1rem;"
                class={"view-wrapper" +
                  (dtype.endsWith("-Radial") ? " radial" : "")}
              >
                <div
                  id={spec.domId}
                  style={"transform-origin: 0 0; text-align: center;" +
                    ($withPPI && $devicePreview
                      ? `transform: scaleX(${
                        Math.min((device_ppi / spec.artboard.ppi) * scale_const, 1)
                        }) scaleY(${Math.min((device_ppi / spec.artboard.ppi) * scale_const, 1)});`
                      : "transform: scaleX(1) scaleY(1);")}
                />
              </div>
            </div>
          </div>
        {/each}
      {/if}
    {/each}
  </div>
{/if}

<style>
  #preview-column {
    display: flex;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
  }
  #preview-column > div {
    scroll-snap-align: start;
  }
  .preview-heading {
    padding: 0 1rem;
    margin: 0.5rem 0 0.25rem 0;
    font-size: 0.75rem;
    font-weight: var(--bold-font-weight);
    color: #757575;
    border: 0;
    background: transparent;
    text-align: left;
  }
  .view-wrapper {
    padding: 1rem;
    margin: 0.5rem 1rem 1rem 1rem;
    border-radius: var(--default-radius);
    border-color: #dddddd;
    background-color: #ffffff;
    overflow: scroll;
  }
  .view-wrapper.radial {
    border-radius: 50% !important;
  }
  #ppi-check .checked {
    color: #0d6efd;
  }
  button {
    background-color: transparent;
  }
  button:hover {
    background-color: white;
  }
</style>
